import { createAsyncThunk } from '@reduxjs/toolkit';
import { reviewsActions } from './reviewsReducer';

// todo: need to update these, for now added some sample
const actionsConfig = {
  fetchAllReviews: {
    thunkName: 'fetchAllReviews',
    method: 'get',
    endpoint: '/reviews',
    reducerName: 'reviews',
  },
  fetchNavigationReviews: {
    thunkName: 'fetchNavigationReviews',
    method: 'get',
    endpoint: '/reviews',
    reducerName: 'navigationReviews',
  },
  fetchReviewersList: {
    thunkName: 'fetchReviewersList',
    method: 'get',
    endpoint: '/reviews/reviewers',
    reducerName: 'reviewersList',
    responseKey: 'data',
  },
  fetchRequestersList: {
    thunkName: 'fetchRequestersList',
    method: 'get',
    endpoint: '/reviews/requesters',
    reducerName: 'requestersList',
    responseKey: 'data',
  },
  fetchProjectsByActiveReviews: {
    thunkName: 'fetchProjectsByActiveReviews',
    method: 'get',
    endpoint: '/projects/list/active_reviews',
    reducerName: 'projectsByActiveReviews',
    responseKey: 'data',
  },
  updateReviewStatus: {
    thunkName: 'updateReviewStatus',
    method: 'put',
    endpoint: '/reviews',
  },
  reviewActions: {
    thunkName: 'reviewActions',
    method: 'put',
    endpoint: '/reviews',
  },
};

const apiAction = async (currentAction, config, args) => {
  // eslint-disable-next-line no-unused-vars
  const [dispatch, getState, extraArgument] = args;
  const { http } = extraArgument;
  const { endpoint, method, reducerName: key, responseKey } = currentAction;
  const { requestConfig = {} } = config;
  const { setLoadingState, fetchSuccess, fetchFailure } = reviewsActions || {};

  dispatch(setLoadingState({ key, isLoading: true }));
  try {
    const result = await http[method](endpoint, { ...requestConfig });
    const response = responseKey ? result[responseKey] : result;
    dispatch(fetchSuccess({ key, data: response, status: result?.status }));
    return response;
  } catch (error) {
    dispatch(fetchFailure({ key, error: error.message }));
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw new Error(`Failed to fetch data from ${endpoint}`);
  }
};

export const reviewsApiActions = (actionId, config = {}) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { urlPaths, isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for reviews');

  let { endpoint, thunkName } = currentAction;

  if (urlPaths) {
    Object.values(urlPaths).forEach((paramValue) => {
      endpoint += `/${paramValue}`;
    });
  }

  if (isApi) {
    return (...args) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args) => {
    return createAsyncThunk(
      thunkName,
      apiAction({ ...currentAction, endpoint }, config, args)
    );
  };
};
